import { Provider } from 'react-redux'
import { QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import store from '@/store/store'
import { queryClient } from '@network/queryClient'
import { ToastContainer } from '@/components/toast'

const Providers = ({ children }) => {
  return (
    <Provider store={store}>
      <ToastContainer />
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>{children}</BrowserRouter>
      </QueryClientProvider>
    </Provider>
  )
}

export default Providers
